<template>
  <div class="car-segment">
    <div class="columns">
      <div class="column">
        <h5 class="is-size-5 has-text-black">{{ segment.carProvider.name }}</h5>

        <div class="is-size-7">
          Confirmation number:

          <span class="has-text-weight-bold">
            {{ segment.confirmationNumber }}</span>
        </div>

        <div class="columns mt-2 mb-0">
          <div class="column">
            <h5 class="is-size-6 mb-1">
              <div class="is-size-7">Pick-Up:</div>
              {{ segment.startDate.date | formatDate }} @
              {{ segment.startDate.time | formatTime }}
              <div class="has-text-grey is-size-7">{{
                segment.pickupLocation
                }}</div>
            </h5>
          </div>
          <div class="column">
            <h5 class="is-size-6 mb-2">
              <div class="is-size-7">Drop-Off:</div>
              {{ segment.endDate.date | formatDate }} @
              {{ segment.endDate.time | formatTime }}
              <div class="has-text-grey is-size-7">{{
                segment.dropoffLocation
                }}</div>
            </h5>
          </div>
        </div>
        <div class="has-text-grey mb-4 is-size-7">
          Trip Length: {{ segment.tripLength }} day(s), starting in
          {{ segment.daysUntilStart }} days
        </div>

        <div class="mb-4" v-if="segment.pricingInfo">
          <div>
            Estimated Total:
            {{ segment.pricingInfo.total | formatPriceFromAmount(2, segment.pricingInfo.currency) }}
            <span class="has-text-grey ">
              ({{ segment.pricingInfo.averagePricePerDay | formatPriceFromAmount(2) }}/day)
            </span>
          </div>
          <div v-if="segment.requestedCurrencyPricing.isConverted" class="mt-1">
            Approximate Total:
            <b-tooltip type="is-dark" position="is-bottom" multilined>
              <template v-slot:content>
                Approximate total - The currency has been converted from {{ segment.pricingInfo.currency }} to {{
                  segment.requestedCurrencyPricing.requestedCurrency }}
              </template>
              <b-icon type="is-success" icon="approximately-equal" size="is-small">
              </b-icon>
            </b-tooltip>
            {{ segment.requestedCurrencyPricing.total | formatPriceFromAmount(2,
              segment.requestedCurrencyPricing.requestedCurrency) }}
            <span class="has-text-grey">
              ({{ segment.requestedCurrencyPricing.averagePricePerDay | formatPriceFromAmount(2,
                segment.requestedCurrencyPricing.requestedCurrency) }}/day)
            </span>
          </div>
        </div>

        <b-taglist>
          <b-tag v-for="(type, index) in segment.vehicleType" :key="index">
            {{ type }}
          </b-tag>
        </b-taglist>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarSegment",
  components: {},
  props: {
    segment: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
